import { createContext } from 'react'

export const PartnerContext = createContext()
